import { createRouter, createWebHistory } from 'vue-router'
import QuoteCreatePage from '@/pages/quote/Create.vue'

const routes = [
    // Optional step param (one record, so step changes don't remount the SPA): /retail-shops/quote[/<step>].
    { path: '/retail-shops/quote/:step?', component: QuoteCreatePage },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router
